import { Loader2 } from 'lucide-react'
import * as React from 'react'
import { Button, type ButtonProps } from '@/components/ui/button'

export interface LoadingButtonProps extends ButtonProps {
  /** When true, shows a spinner, disables the button, and (if provided) swaps label to `loadingText`. */
  loading?: boolean
  /** Optional label shown while loading. Falls back to the button's regular children. */
  loadingText?: React.ReactNode
}

const LoadingButton = React.forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ loading = false, loadingText, disabled, children, ...props }, ref) => (
    <Button ref={ref} disabled={disabled || loading} aria-busy={loading} {...props}>
      {loading && <Loader2 className="animate-spin" aria-hidden="true" />}
      {loading && loadingText !== undefined ? loadingText : children}
    </Button>
  ),
)
LoadingButton.displayName = 'LoadingButton'

export { LoadingButton }
